import { z } from 'zod';

export const TaskSchema = z.object({
  key: z.number().int(),
  done: z.boolean(),
  content: z.string().min(1),
});

export type Task = z.infer<typeof TaskSchema>;
